module.exports = __webpack_public_path__ + "img/datebg.60326187.png";